module.exports = __webpack_public_path__ + "img/011.0f4e13a0.jpg";